import { postCustomBookingsSearch } from "../../../app/api/postCustomBookingsSearch";
import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { getUserProfile } from "../../../Lib/Utils/SessionStorageUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import type { IBookingsListPagination } from "../../../Orchestrator/Recoils/BookingAtom";
import { IBookingSearchResult, IBookingsSearchRequest } from "../../../Orchestrator/Types/Index";
import { IMonthFilterActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";
import { BOOKINGS_MAX_FETCH, BOOKINGS_PAGE_SIZE, processBookingsList, warnIfBookingsTruncated } from "./UpcomingPastBookingTabAction";
import { sortBookingSummariesForDisplay } from "./bookingDisplayPagination";

class UpcomingPastBookingMonthFilterAction extends BaseAction<void, IMonthFilterActionParams> {

    override async run(): Promise<void> {
        try {
            const { filterKey, isAnonymous = false, retrieveBookingsIds = [] } = this.params!

            //Clear existing search train
            updateRecoilState('bookedTripsAtom', []);

            // Set Month To past booking filter
            updateRecoilState("lastMonthAtom", filterKey)

            const currentDateTime = new Date();
            currentDateTime.setUTCHours(currentDateTime.getUTCHours() + 4);

            // Current date with current time for endDate
            currentDateTime.setSeconds(currentDateTime.getSeconds() - 1)
            const endDate = currentDateTime.toISOString()

            // Start date three months back with start of the day time
            const currentDateTimeForMonth = new Date();
            currentDateTimeForMonth.setUTCHours(currentDateTimeForMonth.getUTCHours() + 4);
            currentDateTimeForMonth.setMonth(currentDateTimeForMonth.getMonth() - filterKey);

            // searchBookingAction.setParams({
            //     startTime: currentDateTimeForMonth.toISOString(),
            //     endDate: endDate,
            //     isBookingScreen: true
            // })
            // await searchBookingAction.execute();

            const session = await getUserProfile();
            const searchRequest: IBookingsSearchRequest = {
                travelDateRange: {
                    startTime: currentDateTimeForMonth.toISOString(),
                    endDate: endDate
                },
                purchaserPassengerEmail: session?.email || ""
            };

            const response: any = await postCustomBookingsSearch(searchRequest, BOOKINGS_MAX_FETCH, 0);

            const allResultsRaw: IBookingSearchResult[] =
                response?.status === 'ok' && response.answer
                    ? (response?.answer?.bookingSearchResults || [])
                    : [];
            warnIfBookingsTruncated(allResultsRaw.length);
            // Past = lazy: sort summaries up front, build only the first page now.
            const allResults = sortBookingSummariesForDisplay(allResultsRaw, "2");
            const firstPage = allResults.slice(0, BOOKINGS_PAGE_SIZE);

            updateRecoilState<IBookingsListPagination>("bookingsListPaginationAtom", {
                activeTab: "2",
                offset: firstPage.length,
                pageSize: BOOKINGS_PAGE_SIZE,
                allResults,
                isLoadingMore: false,
                lastSearchRequest: searchRequest,
                lastIsAnonymous: !!isAnonymous,
                lastRetrieveBookingsIds: retrieveBookingsIds || [],
            });

            await processBookingsList(firstPage, "2", !!isAnonymous);


        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            _eventBus.emit({
                eventName: "BOOKING_DATA_LOADED"
            });
        }
    }
}

export const upcomingPastBookingMonthFilterAction = new UpcomingPastBookingMonthFilterAction()
